import * as React from "react";
import { InfoWindowF } from "@react-google-maps/api";
import { Heading } from "@ogt/ui";

type Props = {
  position: google.maps.LatLngLiteral;
  title?: string;
  onClose?: () => void;
};

export default function LlInfoWindow({
  position,
  title = "Plats",
  onClose,
}: Props) {
  return (
    <InfoWindowF
      position={position}
      onCloseClick={onClose}
      options={{
        disableAutoPan: false,
        pixelOffset: new google.maps.Size(0, -12),
      }}
    >
      <div className="pt-0 pl-4 pr-6 pb-6 min-w-[220px] text-sm leading-snug bg-[var(--semantic-color-bg-primary)]">
        <div className="flex gap-2 mb-4 items-center">
          <Heading
            as="h3"
            className="text-[var(--semantic-color-text-secondary)] mb-0"
          >
            {title}
          </Heading>
        </div>
      </div>
    </InfoWindowF>
  );
}
